import React, { useEffect, useRef, useState } from 'react'
import { Template } from '../../Components/Template/template'
import { AlertType, Produto, classDivBackground, classInput, classLabel, classInputDark, classLabelDark, classbtAzul, classBt, AcertoEstoque, classBorderLabelDark, classDivBody, classbtCinzaClaro, KEY_CODE_ENTER, classDivTitulo, SangriaSuprimento, TipoSangriaSuprimento, InputsRefs } from '../../Utils/Types'
import { IoCameraOutline, IoSave, IoSearch } from 'react-icons/io5'
import { ProdutoService } from '../Products/ProdutoService'
import { Funcoes } from '../../Utils/Funcoes'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { AiOutlineClear } from 'react-icons/ai'
import { MdEditDocument } from 'react-icons/md'
import moment from 'moment'
import { SupSangriaService } from './SupSangriaService'
import { GiMoneyStack } from 'react-icons/gi'

export const SupSangria = () => {

    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")
    const [tipo, setTipo] = useState<TipoSangriaSuprimento>("S")
    const [valor, setValor] = useState("0.00")
    const [observacao, setObservacao] = useState("")


    useEffect(() => {
        Inputfocus()
    }, []);

    // ---------------------------------------------------------------------------- INPUTS --------------------------------------------------------------------

    const handleChangeTipo = (e: React.ChangeEvent<HTMLSelectElement>) => {

        if (e.target.value === "S") { // Suprimento            
            setTipo("S")
        } else { // Sangria
            setTipo("A")
        }
    }

    const handleChangeValor = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValor(Funcoes.MaskMoney(e.target.value))
    }

    const handleLimparDados = () => {

        setTipo("S")
        setValor("0.00")
        setObservacao("")
        Inputfocus()

        if (messageType === 'DANGER') {
            setVisible(false)
        }

    }

    const handleChangeObservacao = (e: React.ChangeEvent<HTMLInputElement>) => {
        setObservacao(e.target.value)
    }

    // ------------------------------------------------------------------------- API--------------------------------------------------------------------------------
    const handleSaveAcerto = async () => {

        setVisible(false)
        setLoading(true)

        try {

            if (parseFloat(valor) <= 0) {

                const timer = setTimeout(() => {
                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage("Valor informado inválido")
                    clearTimeout(timer)
                }, 250)
                return
            }

            const dados: SangriaSuprimento = {
                data: moment().format("YYYY-MM-DD"),
                observacao: observacao,
                valor: parseFloat(valor),
                tipo: tipo
            }

            const retApi = await SupSangriaService.Save(dados)

            if (retApi.error) {
                setVisible(true)
                setMessageType("DANGER")
                setMessage(retApi.msg || '')
                
            }else {

                setVisible(true)
                setMessageType("SUCCESS")
                setMessage('Lançamento efetuado com sucesso')
    
                setTipo("S")
                setValor("0.00")
                setObservacao("")

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage('Houve um erro ao fazer o lançamento. Por favor, tente novamente.')

        } finally {
            setLoading(false)
            Inputfocus()
        }
    }


    // ------------------------------------------------------------------------- FUNÇÕES DE FOCUS E MENSAGEM --------------------------------------------------------
    const handleCloseMessage = () => {
        setVisible(false)
    }

    const Inputfocus = () => {
        const inputElement = document.getElementById("tipo")
        inputElement?.focus()
    }

    // ---------------------------------------------------------------- FOCUS -----------------------------------------------------------------
    const inputsRefs: InputsRefs = {
        tipoLancamento: useRef(null),
        valorLancamento: useRef(null),
        observacao: useRef(null),

    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab') {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length
            } while (
                (inputsRefs[keys[nextIndex]].current?.disabled || inputsRefs[keys[nextIndex]].current?.tabIndex === -1) &&
                nextIndex !== currentIndex
            )

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            inputsRefs[keys[nextIndex]].current?.focus()
        }
    }

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`h-[50px] w-full flex items-center my-3 px-2 border border-x-0 border-t-0 border-slate-300 dark:border-slate-700`}>
                            <GiMoneyStack className={`text-slate-700 dark:text-slate-200 ml-2 mr-2`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 break-all`}>Suprimento e Sangria</span>
                        </div>

                        <div className={`w-full h-full grid gap-4 grid-cols-12 p-4`}>

                            <div className={`relative col-span-12 sm:col-span-4 md:col-span-3 xl:col-span-2 mt-4`}>
                                <select ref={inputsRefs.tipoLancamento} onKeyDown={(e) => handleTabPress(e, 'tipoLancamento')} id='tipo' className={`${classInput} ${classInputDark}`} value={tipo} onChange={handleChangeTipo}>
                                    <option value="A">Sangria</option>
                                    <option value="S">Suprimento</option>
                                </select>
                                <label htmlFor="tipo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Tipo do Lançamento</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-8 md:col-span-4 xl:col-span-2 mt-4`}>
                                <input ref={inputsRefs.valorLancamento} onKeyDown={(e) => handleTabPress(e, 'valorLancamento')} id='valor' className={`${classInput} ${classInputDark} first-letter:h-[40px]`} type='text' inputMode='numeric' placeholder=' ' value={valor} onChange={handleChangeValor} />
                                <label htmlFor="valor" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor do lançamento</label>
                            </div>

                            <div className={`relative col-span-12 md:col-span-5 xl:col-span-8 mt-4`}>
                                <div className={`flex w-full h-[40px] items-center`}>
                                    <div className={`relative w-full`}>
                                        <input ref={inputsRefs.observacao} onKeyDown={(e) => handleTabPress(e, 'observacao')} id='observacao' className={`${classInput} ${classInputDark} w-full`} placeholder=' ' autoComplete='off' value={observacao} onChange={handleChangeObservacao} />
                                        <label htmlFor="observacao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Observação</label>
                                    </div>

                                </div>
                            </div>

                            <div className={`flex justify-end relative w-full col-span-12 mt-2 mr-2`}>

                                <button tabIndex={-1} className={`${classBt} ${classbtCinzaClaro} max-w-[150px] mr-2`} onClick={handleLimparDados}>
                                    <AiOutlineClear size="18px" className={`mr-[5px]`} /><span className='mx-1'>Limpar Campos</span>
                                </button>

                                <button tabIndex={-1} className={`${classBt} ${classbtAzul} max-w-[150px] ml-2`} onClick={handleSaveAcerto}>
                                    <IoSave size="18px" className={`mr-[5px]`} /><span className='mx-1'>Salvar</span>
                                </button>
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </Template>


    )
}